const MyanmarSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111959)">
      <path
        d="M38.756 26.9568C39.56 24.7902 40 22.4467 40 20.0003C40 17.5539 39.56 15.2104 38.756 13.0438L20 11.3047L1.24398 13.0438C0.440078 15.2104 0 17.5539 0 20.0003C0 22.4467 0.440078 24.7902 1.24398 26.9568L20 28.6959L38.756 26.9568Z"
        fill="#6DA544"
      />
      <path
        d="M38.7557 13.0435C35.9298 5.4275 28.599 0 19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7557Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
      <path
        d="M33.7152 16.9213H23.2381L20.0004 6.95703L16.7628 16.9213H6.28564L14.7618 23.0796L11.5242 33.0441L20.0004 26.957L28.4767 33.044L25.2391 23.0795L33.7152 16.9213Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111959">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MyanmarSvg;
